import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import "./Loan.css"; // Your custom CSS
import { useCombinedContext } from "../../context/CombinedContext";

const formatDate = (isoString) => {
  if (!isoString) return "_____________";
  const dateObj = new Date(isoString);
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();
  return `${day}-${month}-${year}`;
};

const LoanView = ({ formatPrice,userRole, loan, isViewMode, setIsViewMode }) => {
  const [isMultiplePages, setIsMultiplePages] = useState(false);
  const { selectedCompany } = useCombinedContext();
  const company = selectedCompany || {};
  const printRef = useRef(null);
  // Check if content is multiple pages
  const checkForMultiplePages = () => {
    if (!printRef.current) return;
    const contentHeight = printRef.current.scrollHeight;
    const pageHeight = 1080; // Adjust as needed
    setIsMultiplePages(contentHeight > pageHeight);
  };

  useEffect(() => {
    checkForMultiplePages();
  }, [printRef]);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: `
      @page {
        size: auto;
        margin: 20mm;
      }
      @page {
        @bottom-right {
          content: "Page " counter(page) " of " counter(pages);
        }
      }
    `,
    onBeforePrint: () => {
      // Hide modal while printing
      setIsViewMode(false);
    },
  });
  if (!isViewMode) return null;
  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      tabIndex="-1"
      role="dialog"
      onClick={(e) => {
        if (e.target.classList.contains("modal")) {
          setIsViewMode(false);
        }
      }}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        style={{ maxWidth: "850px" }}
        role="document"
      >
        <div className="modal-content">
          {/* Modal Header */}
          <div
            className="modal-header d-print-none"
            style={{ borderBottom: "none" }}
          >
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => setIsViewMode(false)}
            />
          </div>
          {/* Printable Content */}
          <div ref={printRef} className="p-3" id="loan">
            {/* Company Header */}
            <div className="text-center mb-3">
              <h5 className="mb-0 text-uppercase">
                {company.company_name || "WHL MARINE ENGINEERING PTE LTD"}
              </h5>
              <p className="mb-0" style={{ fontSize: "12px" }}>
                {company.address ||
                  "2 Bukit Batok Street 24 #02-13 Skytech, Singapore 659480"}
              </p>
              <p className="mb-0" style={{ fontSize: "12px" }}>
                Email: {company.email || "navene.p@whlmx.com.sg"}
              </p>
            </div>
            <hr />

            {/* Form Title */}
            <div className="text-center mb-3">
              <h6 className="text-decoration-underline text-uppercase">
                CASH ADVANCE REQUEST FORM
              </h6>
            </div>

            {/* Date (Formatted) */}
            <div className="mb-2">
              <label className="fw-bold me-2">Date:</label>
              <span>{formatDate(loan?.loanDate)}</span>
            </div>
            <h6 className="text-decoration-underline" style={{ fontSize: "14px" }}>
              Request Personal Information
            </h6>
            {/* Request Personal Information */}

            <div className="mb-3">
              <tbody className="pt-2 fs-7">
                <tr>
                  <td>Employee Name&nbsp;</td>
                  <td>:&nbsp;{loan?.employee?.name || "_____________"}</td>
                </tr>
                <tr>
                  <td>ID/Work Permit No&nbsp;</td>
                  <td>:&nbsp;{loan?.employee?.employeeNo || "_____________"}</td>
                </tr>
                <tr>
                  <td>Work Permit Exp Date&nbsp;</td>
                  <td>
                    :&nbsp;
                    {formatDate(loan?.employee?.expiryDate) || "_____________"}
                  </td>
                </tr>
                <tr>
                  <td>Request Amount&nbsp;</td>
                  <td>:&nbsp;$ {formatPrice(loan?.loanAmount) || "_____________"}</td>
                </tr>
              </tbody>
            </div>

            {/* Repayment Details */}
            <h6 className="text-decoration-underline" style={{ fontSize: "14px" }}>
              Repayment Details
            </h6>
            <div className="mb-3">
              <tbody>
                <tr>
                  <td>Payment Terms&nbsp;</td>
                  <td>:&nbsp;MONTHLY</td>
                </tr>
                <tr>
                  <td>Payroll Deduction&nbsp;</td>
                  <td>:&nbsp;_________________________</td>
                </tr>
              </tbody>
            </div>

            {/* Authorization Text & Signature */}
            <div className="mb-4" style={{ minHeight: "80px" }}>
              <div
                className="border border-dark"
                style={{ height: "auto", width: "50%", padding: "5px" }}
              >
                <p style={{ fontSize: "13px" }} className="mb-5">
                  I/we hereby authorize WHL Marine Payroll department to deduct
                  my repayment amount from salary.
                </p>
                <p className="mb-0 text-center mt-5">Signature</p>
              </div>
            </div>

            {/* Approval Section */}
            <h6 className="text-decoration-underline mb-2" style={{ fontSize: "14px" }}>
              Approval Section
            </h6>
            <table
              className="table table-bordered border-dark"
              style={{ fontSize: "14px" }}
            >
              <thead className="text-center">
                <tr>
                  <th style={{ width: "33%" }}>Operations Director</th>
                  <th style={{ width: "33%" }}>Director</th>
                  <th style={{ width: "34%" }}>Account Department</th>
                </tr>
              </thead>
              <tbody className="text-center">
                <tr>
                  <td>
                    <div className="approvel">
                      <input
                        type="checkbox"
                        disabled
                        className="small_checkbox"
                      />
                      <span>Approved</span>
                    </div>
                    <div className="approvel">
                      <input
                        type="checkbox"
                        disabled
                        className="small_checkbox"
                      />
                      <span>Not Approved</span>
                    </div>
                    <br />
                    <br />
                    <br />
                    <p className="">.....................................</p>
                  </td>
                  <td>
                    <div className="approvel">
                      <input
                        type="checkbox"
                        disabled
                        className="small_checkbox"
                      />
                      <span>Approved</span>
                    </div>
                    <div className="approvel">
                      <input
                        type="checkbox"
                        disabled
                        className="small_checkbox"
                      />
                      <span>Not Approved</span>
                    </div>
                    <br />
                    <br />
                    <br />
                    <p className="">.....................................</p>
                  </td>
                  <td>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <p className="">.....................................</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Print Button (Admin only) */}
          <div className="d-print-none text-center mb-3">
            {loan.status === "Approved" && (
              <button className="button-2" onClick={handlePrint}>
                Print Loan
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanView;
